import React, { Component } from 'react';
import { Form, Input, Button } from 'antd';

class RegisterForm extends Component {
  formRef = React.createRef();

  componentDidUpdate(prevProps) {
    // 當初始值改變時，更新表單內容
    if (prevProps.initialValues !== this.props.initialValues) {
      this.formRef.current?.setFieldsValue(this.props.initialValues);
    }
  }

  render() {
    const { onFinish, errorMessage } = this.props;

    return (
      <>
        <Form
          ref={this.formRef}
          layout="vertical"
          onFinish={onFinish}
          initialValues={this.props.initialValues}
        >
          <Form.Item label="AWS Account ID" name="customerId">
            <Input disabled />
          </Form.Item>

          <Form.Item
            label="Account Name"
            name="account"
            rules={[
              { required: true, message: 'Please enter your account name' },
              { min: 8, message: 'Account name must be at least 8 characters' },
              { max: 20, message: 'Account name must be at most 20 characters' },
              {
                pattern: /^[A-Za-z0-9_]+$/,
                message: 'Account name can only contain letters, numbers, and underscores',
              },
            ]}
          >
            <Input placeholder="Please enter your account name" autoComplete="off" maxLength={30} />
          </Form.Item>

          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: 'Please enter your Email' },
              { type: 'email', message: 'Invalid email format' },
            ]}
          >
            <Input placeholder="Please enter your Email" autoComplete="off" maxLength={30} />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[
                { required: true, message: 'Please enter your password' },
                { min: 8, message: 'Password must be at least 8 characters' },
                { max: 32, message: 'Password must be at most 32 characters' },
                {
                  pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*]).+$/,
                  message: 'Password must include letters, numbers, and special characters',
                },
              ]}          >
            <Input.Password placeholder="Please enter your password" maxLength={30} />
          </Form.Item>

          <Form.Item name="dimension" label="Plan">
            <Input disabled />
          </Form.Item>

          <Form.Item name="expiresAt" label="Subscription End Date">
            <Input disabled />
          </Form.Item>

          {errorMessage && (
            <div style={{ color: 'red', marginBottom: '1rem' }}>{errorMessage}</div>
          )}

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Create Account
            </Button>
          </Form.Item>
        </Form>
      </>
    );
  }
}

export default RegisterForm;